<template>
	<div v-if="loaded">
		<div class="form" >
			<div class="step_title" v-html="words.step+' '+ step"></div>
			<h2 class="title" v-html="words.payment_info"></h2>
			
			<template v-if="paymentId && paymentId > 0">
				<iframe :src="paymentUrl"></iframe>
			</template>
			<a class="go_back under_line" @click="$emit('returnStep')" tabindex="0" v-html="words.return_step"></a>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
		isLoading: false,
		loaded:false,
		paymentId:0,
		paymentUrl:'',
		credit:{
			number:'',
			id:'',
			expire:'',
			cvv:''
		},
	}
  },
  props: {
    step: {
      required: true,
      type: Number,
    },
  },
  computed: {
    words() {
      return this.$store.state.words
    },
  },
  mounted(){
	this.getPayment();
  },
  methods: {
		getPayment() {
			this.$store.commit('setIsLoading', {isLoading: true});
			this.api({ action: 'create_payment'}, (data)=> {
				this.paymentId = data.data.payment_id;
				this.paymentUrl = data.data.payment_link;
				this.$store.commit('setIsLoading', {isLoading: false});
				this.loaded = true;
			})
		},
  },
}
</script>

<style lang="scss" scoped>
	iframe{border: none;max-height: 700px;width:100%;height: 500px;overflow-y: scroll;margin: 30px 0;}
</style>